import { render } from "./AuditTemplateContent.vue?vue&type=template&id=3bd1c1f4&scoped=true"
import script from "./AuditTemplateContent.vue?vue&type=script&lang=js"
export * from "./AuditTemplateContent.vue?vue&type=script&lang=js"

import "./AuditTemplateContent.vue?vue&type=style&index=0&id=3bd1c1f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd1c1f4"]])

export default __exports__